module.exports = __webpack_public_path__ + "img/800x800transparent.aa4dd5e4.png";